module.exports = __webpack_public_path__ + "img/flow-light.083b2680.png";